import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { AppCoreService } from '../services/app-core.service';
//import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import { SecurityService } from '../services/security.service';
import { UtilitiesService } from '../services/utilities.service';
import { ClientConfigModel } from '../../shared/models/client/client-config.model';

@Injectable({
	providedIn: 'root'
})
export class DynamicRouteGuardService implements CanActivate {
	constructor(
		private router: Router,
		private appCoreService: AppCoreService,
		private securityService: SecurityService
	) {}

	public canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean {
		return this.appCoreService.isLive ? this.overrideRoute(route) : false;
	}

	private async overrideRoute(route: ActivatedRouteSnapshot): Promise<boolean> {
		const clientConfig: ClientConfigModel = this.appCoreService.clientConfig;
		const url = this.getResolvedUrl(route);
		const allowedRoutes: string[] = clientConfig?.routes?.allowedRoutes;
		const defaultRoute: string = clientConfig?.routes?.defaultRoute || '/';

		if (this.appCoreService.currentApplication.hasClientCredentials) {
			await this.securityService.loginClient();
		}

		// if default route is defined and there is no route
		if (clientConfig?.routes?.defaultRoute && (url == '/' || url == '')) {
			// Redirect to default route
			return this.router.navigate([defaultRoute]).then(() => {
				return false;
			});
		} else if (allowedRoutes && allowedRoutes[0] && url != '/admin/client-config' && url != '/security/login') {
			let match = false;

			// looping through allowed routes to see if url contains allowed routes
			for (const ar of allowedRoutes) {
				if (url.includes(ar)) {
					match = true;
					break;
				}
			}

			// no match, return to the default route
			if (!match) {
				return this.router.navigate([defaultRoute]).then(() => {
					return false;
				});
			}
			// there was a match, so resolve the route.
			else {
				return Promise.resolve(true);
			}
		} else if (this.appCoreService.isDBReady && url == '/security/maintenance') {
			return this.router.navigate([defaultRoute]).then(() => {
				return false;
			});
		} else if (!this.appCoreService.isDBReady && url != '/security/maintenance') {
			return this.router.navigate(['/security/maintenance']).then(() => {
				return false;
			});
		} else {
			return Promise.resolve(true);
		}
	}

	private getResolvedUrl(route: ActivatedRouteSnapshot): string {
		return route.pathFromRoot.map((v) => v.url.map((segment) => segment.toString()).join('/')).join('/');
	}

	private getConfiguredUrl(route: ActivatedRouteSnapshot): string {
		return (
			'/' +
			route.pathFromRoot
				.filter((v) => v.routeConfig)
				.map((v) => v.routeConfig!.path)
				.join('/')
		);
	}
}
